import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { FroalaComponent } from '@shared/components/froala/froala.component';
import { CipoDialogHeaderComponent } from '@shared/dialogs';
/* Import from it's file to avoid CD */
import { CipoDialogModule } from '@shared/modules/cipo-dialog.module';

/**
 * A simple dialog that displays some info.
 *
 * #### Usage
 *
 * ```ts
 * this.dialog.open(InfoDialog, {
 *    data: {
 *      title: 'MODULE.DIALOG_DELETE.TITLE',
 *      messages: ['MODULE.DIALOG_DELETE.MESSAGE1', 'MODULE.DIALOG_DELETE.MESSAGE2'],
 *      // or, if you have only one message:
 *      description: 'MODULE.DIALOG_DELETE.DESCRIPTION',
 *    } as InfoDialogData,
 *  }).afterClosed().subscribe(() => ...do something...);
 * ```
 */
@Component({
  selector: 'cipo-info-dialog',
  templateUrl: './info-dialog.component.html',
  imports: [CipoDialogModule, CipoDialogHeaderComponent, FroalaComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoDialog {
  readonly data = inject<InfoDialogData>(MAT_DIALOG_DATA);

  trackBy(index: number, message: string) {
    return `${index} -- ${message}`;
  }
}

export interface InfoDialogData {
  title: string;
  messages?: string[];
  description?: string;
  isFroala?: boolean;
  enableFullscreen?: boolean;
}
